/** User-facing text for an API error from HuntApiService. */
export function accessMessage(e: { status?: number; message?: string }): string {
  if (e && e.status === 403) {
    return "You're not on the hunt-admin list. Ask an existing hunt admin to add you under Explorer > Settings > Hunt admins.";
  }
  if (e && e.status === 401) return 'Your sign-in has expired. Log out and sign in again.';
  return (e && e.message) || 'Something went wrong.';
}
